// about-us-faq: the accordion questions, tabbed mode and the "Show more" button.
//
// Every handler is delegated from the document rather than bound per element
// on DOMContentLoaded. The PDP family switcher replaces this section with
// fresh markup on every switch (replaceNonMainSections), and the theme editor
// re-renders it; listeners bound to the old nodes never reached the new ones,
// so after a switch the questions stopped opening. The questions, tabs and
// "Show more" are real <button>s, so Enter and Space arrive here as clicks.
(function () {
  if (window.__jiyuAboutUsFaq) return;
  window.__jiyuAboutUsFaq = true;

  function setOpen(question, open) {
    // By position, not aria-controls: a page Shopify cached before the
    // questions became buttons has no ids, and this script serves it too.
    const item = question.closest(".faq-item");
    const answer = item && item.querySelector(".faq-answer");
    if (!answer) return;

    item.classList.toggle("active", open);
    question.setAttribute("aria-expanded", open ? "true" : "false");
    answer.style.maxHeight = open ? answer.scrollHeight + "px" : "0px";
  }

  // ARIA tabs: the selected tab is the only one in the Tab order.
  function selectTab(tab, moveFocus) {
    const sectionEl = tab.closest(".about-us-faq");
    if (!sectionEl) return;

    const target = tab.getAttribute("data-faq-tab");
    sectionEl.querySelectorAll("[data-faq-tab]").forEach((t) => {
      const isActive = t === tab;
      t.classList.toggle("is-active", isActive);
      t.setAttribute("aria-selected", isActive ? "true" : "false");
      if (isActive) t.removeAttribute("tabindex");
      else t.setAttribute("tabindex", "-1");
    });
    sectionEl.querySelectorAll("[data-faq-tab-panel]").forEach((p) => {
      p.classList.toggle("is-active", p.getAttribute("data-faq-tab-panel") === target);
    });
    // Re-measure any open accordion items in the newly visible panel
    // (their scrollHeight was 0 while hidden).
    sectionEl.querySelectorAll("[data-faq-tab-panel].is-active .faq-item.active .faq-answer").forEach((ans) => {
      ans.style.maxHeight = ans.scrollHeight + "px";
    });
    if (moveFocus) tab.focus();
  }

  function showMore(button, event) {
    const sectionEl = button.closest(".about-us-faq");
    if (!sectionEl) return;

    const revealed = Array.from(sectionEl.querySelectorAll(".faq-item.is-hidden"));
    revealed.forEach((item) => item.classList.remove("is-hidden"));

    // The button hides itself, which would drop a keyboard user's focus to
    // <body>: hand it to the first question it revealed. detail 0 is Enter,
    // Space or assistive tech; isTrusted rules out a script's el.click().
    if (event.detail === 0 && event.isTrusted && revealed.length) {
      const question = revealed[0].querySelector(".faq-question");
      if (question) question.focus();
    }
    button.hidden = true;
  }

  document.addEventListener("click", (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const question = target.closest(".about-us-faq .faq-question");
    if (question) {
      setOpen(question, question.getAttribute("aria-expanded") !== "true");
      return;
    }
    const tab = target.closest(".about-us-faq [data-faq-tab]");
    if (tab) {
      selectTab(tab, false);
      return;
    }
    const more = target.closest(".about-us-faq [data-faq-show-more]");
    if (more) showMore(more, event);
  });

  // Arrow keys, Home and End move between the tabs (a horizontal tablist).
  document.addEventListener("keydown", (event) => {
    if (event.altKey || event.ctrlKey || event.metaKey) return;
    const tab = event.target instanceof Element && event.target.closest(".about-us-faq [role='tab']");
    if (!tab) return;
    const tablist = tab.closest("[role='tablist']");
    if (!tablist) return;

    const tabs = Array.from(tablist.querySelectorAll("[role='tab']"));
    const i = tabs.indexOf(tab);
    let next = null;
    if (event.key === "ArrowRight") next = tabs[(i + 1) % tabs.length];
    else if (event.key === "ArrowLeft") next = tabs[(i - 1 + tabs.length) % tabs.length];
    else if (event.key === "Home") next = tabs[0];
    else if (event.key === "End") next = tabs[tabs.length - 1];
    if (!next) return;

    event.preventDefault();
    selectTab(next, true);
  });

  // Sync to the homepage product switcher: when the customer changes
  // products there, click the FAQ tab whose data-faq-tab-product-handle
  // matches. Tabs without a handle (e.g. the brand-general "JiYu" tab)
  // are simply skipped.
  //
  // v3 bundle handling: in v3 the switcher has a "Bundle & Save" tab
  // backed by N bundle products (clarify-glow, total-reset, etc), not
  // just one. The FAQ section typically has a single "Bundle" tab
  // configured for one bundle handle (legacy: test-complete-care-bundle).
  // So when the customer lands on ANY bundle, we want to activate the
  // FAQ section's bundle tab regardless of which specific bundle they
  // viewed. Detection: if the switcher renders an active bundles tab,
  // collect all configured bundle handles from the inline grid cards,
  // then activate the FAQ tab matching ANY of them.
  document.addEventListener("jiyu:hps:product-changed", (e) => {
    const handle = e.detail && e.detail.handle;
    if (!handle) return;

    let handlesToTry = [handle];
    const onBundle = !!document.querySelector(
      "[data-homepage-product-switcher] [data-pfs-bundles-tab].pfs__option--active"
    );
    if (onBundle) {
      const bundleHandles = Array.from(
        document.querySelectorAll(
          "[data-homepage-product-switcher] .pfs__bundle-card[data-handle]"
        )
      )
        .map((c) => c.getAttribute("data-handle"))
        .filter(Boolean);
      // Try the current handle first (preferred — exact match wins if a
      // FAQ tab happens to be configured for that specific bundle), then
      // fall back to any other configured bundle handle.
      handlesToTry = [handle, ...bundleHandles.filter((h) => h !== handle)];
    }

    document.querySelectorAll(".about-us-faq").forEach((sectionEl) => {
      for (const h of handlesToTry) {
        const match = sectionEl.querySelector(
          `[data-faq-tab][data-faq-tab-product-handle="${h}"]`
        );
        if (match) {
          if (!match.classList.contains("is-active")) selectTab(match, false);
          break;
        }
      }
    });
  });
})();
